import React, { useEffect } from 'react'
import { useConcursoTikTok } from "../../../../hooks/useConcursoTikTok2025"
import { pathImages, pathPDF } from "../../../../routes/endpoints";

const Bases = () => {

    const { bases, getBases } = useConcursoTikTok();

    useEffect(() => {
        getBases(2026)
    }, [])

    return (
        <div className="container-fluid section-home" id="bases">
            <div className="row justify-content-center">
                <div className="col-12 anchor-section">
                </div>
                <div className="col-md-8 inner-sections">
                    <div className="title-tiktok-info">
                        <h2>Bases y documentos</h2>
                    </div>
                    <div className="container-inner-info p-4">
                        <div className="rules-section-grid">
                            {
                                bases.map(({ nombre, descripcion, icono,pdf }, i) => (
                                    <div className="inner-rules">
                                        <a target='_blank' href={`${pathPDF}${pdf}`}>
                                            <div className="img-rules">
                                                <img src={`${pathImages}${icono}`} alt={nombre}/>
                                            </div>
                                            <div className="info-rules">
                                                <h3>{nombre}</h3>
                                                <div className="line-title-rules"></div>
                                                <p className="text-rules">{descripcion}</p>
                                            </div>
                                        </a>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Bases
